





























































































































































































import { Component, Vue, Prop, Watch} from 'vue-property-decorator';
import Ajax from '../../../lib/ajax'
import AbpBase from '../../../lib/abpbase'
import Appconst from '../../../lib/appconst';
@Component({
    name:'scientficProjectAdd'
})
export default class ScientficProjectAdd extends AbpBase  {
    @Prop() editData:Object;
    initData:any = {
        formData: {
            attachs:[]
        },
        dicData: {
            researchProjectCatalog: []
        },
        fileUrl: Appconst.fileUrl,  //附件上传地址
        defaultList:[],//编辑时候已经上传的附件
        disabled:false,
        createOrUpdateMembers:[
            {
                memberName:'',
                memberTitle:'',
                workUnit:'',
                workTask:'',
                workTime:'',
                isProjectLeader:true
            }
        ], // 项目负责人成员
        deleteMemberIds:[], // 删除项目负责人的id
    }
    //附件上传成功
    fileSuccess(res:any){
        this.initData.formData.attachs.push(res.result);
    }
    //附件上传失败
    fileRemove(res:any){
        if(res.response){
           Ajax.post('/api/File/DeleteTempFile?fileName='+res.response.result)
            this.initData.formData.attachs.splice(this.initData.formData.attachs.indexOf(res.response.result),1); 
        }else{
            Ajax.delete('/api/services/app/ResearchProject/DeleteProjectAttachAsync?Id='+res.id);
        }
    }
    // 添加项目组成员
    addMembers() {
        if(this.initData.createOrUpdateMembers.length > 4){
            this.$Message.error('项目组成员最多只能填写5位!');
            return;
        }
        if(!this.initData.createOrUpdateMembers[0].memberName){
            this.$Message.error('请填写项目组成员!');
            return;
        }
        this.initData.createOrUpdateMembers.push(
                {
                    memberName:'',
                    memberTitle:'',
                    workUnit:'',
                    workTask:'',
                    workTime:null,
                    isProjectLeader:false
                }
            );
    }
    // 删除项目组成员  院-17-1
    deleteMember(data:any,index:any) {
        if(data.id){
            this.initData.createOrUpdateMembers.splice(index,1);
            this.initData.deleteMemberIds.push(data.id);
        }else{
            this.initData.createOrUpdateMembers.splice(index,1);
        }
    }
    // 改变当前的项目成员
    changeMember(value:any) {
        this.initData.dicData.allPersonNoPermission.forEach( (item:any) => {
            if(item.value == value) {
                this.initData.createOrUpdateMembers[0].memberName = item.label;
            }
        } )
    }
    //提交
    async Submit(type:any) {
        (this.$refs.addForm as any).validate(async (valid:boolean)=>{
            if(valid){
                this.initData.formData.ratifyYear = new Date(this.initData.formData.ratifyDt).getFullYear();
                (this as any).$parent.$parent.initData.btnLoading = true;
                // 格式化
                this.initData.formData.createOrUpdateMembers = [];
                this.initData.createOrUpdateMembers.forEach( (item:any) => {
                    if(item.memberName) {
                        item.workTime = item.workTime ? Number(item.workTime):0;
                        this.initData.formData.createOrUpdateMembers.push(item);
                    }
                } );
                // return;
                if(type === 'add'){
                    await Ajax.post('/api/services/app/ResearchProject/CreateProjectAsync', this.initData.formData).then( ()=>{
                        // this.$Modal.confirm({
                        //     title: '科研项目登记',
                        //     content: '<h3>科研项目登记申请已提交！</h3>',
                        //     okText:'是',
                        //     cancelText:'暂不填写',
                        //     onOk: () => {
                        //         this.$router.push({name: 'scientficProject'});
                        //     },
                        //     onCancel: () => {
                        //         this.$router.push({name: 'scientficProject'});
                        //     }
                        // })
                        this.$Modal.success({
                            title: '科研项目登记',
                            content: '<h3>科研项目登记申请已提交！</h3>',
                            onOk: ()=>{
                                this.$router.push({name: 'scientficProject'})
                            }
                        });

                    } ).catch( ()=>{
                        setTimeout( () => {
                            (this as any).$parent.$parent.initData.btnLoading = false;
                        },2000)
                    } );   
                    
                }else{
                    if(this.initData.deleteMemberIds && this.initData.deleteMemberIds.length){
                        this.initData.formData.deleteMemberIds = this.initData.deleteMemberIds;
                    }
                    this.initData.formData.createOrUpdateMembers = [];
                    this.initData.createOrUpdateMembers.forEach( (item:any) => {
                        if(item.memberName) {
                            item.workTime = item.workTime ? Number(item.workTime):0;
                            this.initData.formData.createOrUpdateMembers.push(item);
                        }
                    } );
                    await Ajax.put('/api/services/app/ResearchProject/UpdateProjectAsync', this.initData.formData).then( ()=>{
                        this.$Message.success('修改成功!');
                        (this as any).$parent.$parent.initData.modalData.status = false; 
                    } ).catch( ()=>{
                       (this as any).$parent.$parent.initData.modalData.status = false; 
                        this.$nextTick( ()=>{
                            (this as any).$parent.$parent.initData.modalData.loading = true; 
                        });
                    } );  
                    (this as any).$parent.$parent.GetData();          
                }
                setTimeout( () => {
                    (this as any).$parent.$parent.initData.btnLoading = false;
                },2000)
            }else{
                setTimeout( () => {
                    (this as any).$parent.$parent.initData.btnLoading = false;
                },2000);
            }
        })
    }
    //获取合同信息
    GetContactInfo(type:number) {
        let code:any = null,
            keyName:any;
        if(type == 1){
            code = this.initData.formData.contractCode;
            keyName = 'contractName';
        }else{
            code = this.initData.formData.externalContractCode;
            keyName = 'externalContractName';
        }
        if(!code){
            this.initData.formData[keyName] = null;
            return;
        };
        Ajax.get('/api/services/app/Contract/GetContractByCodeAsync?ContractCode='+code).then((res:any)=>{
            this.initData.disabled = false;
            //合同信息
            this.$set(this.initData.formData, keyName, res.data.result.contractName);  
            this.$set(this.initData.formData, 'projectName', res.data.result.contractName);
            this.$set(this.initData.formData,'contractAmount',res.data.result.contractAmount);
            this.$set(this.initData.formData,'beginDt',res.data.result.beginDt);
            this.$set(this.initData.formData,'endDt',res.data.result.endDt);
            this.$set(this.initData.formData,'trusteeshipDepId',res.data.result.belongOrgId);
            this.$set(this.initData.formData,'projectLeaderId',res.data.result.contractProjectLeaderId);
            // 获取项目负责人
            this.initData.dicData.allPersonNoPermission.forEach( (item:any) => {
                if(item.value == res.data.result.contractProjectLeaderId) {
                    this.initData.createOrUpdateMembers[0].memberName = item.label;
                }
            } )
        })
    }
    //重置弹窗
    ResetForm() {
        (this as any).$refs.addForm.resetFields();
        this.initData.formData = {}
    }
    async GetDic() {
        await this.$store.dispatch('project/GetResearchProjectCatalog');
        await this.$store.dispatch('project/GetAllUser');
        await this.$store.dispatch('project/GetbearerOrg');
        await this.$store.dispatch('project/GetAllOrganization');
        //合同签订人查询特殊接口
        await this.$store.dispatch({type: 'project/GetAllPersonNoPermission'});  
        this.initData.dicData.researchProjectCatalog = this.$store.state.project.researchProjectCatalog;
        this.initData.dicData.userList = this.$store.state.project.userList;
        this.initData.dicData.allPersonNoPermission = this.$store.state.project.allPersonNoPermission;
        this.initData.dicData.bearerOrg = this.$store.state.project.bearerOrgAll;
    }
    //验证规则
    rules:any = {
        // contractCode: [{ required: true, message: '请填写合同编号', trigger: 'blur' }],
        projectCode: [{ required: true, message: '请填写项目编号', trigger: 'blur' }],
        projectName: [{ required: true, message: '请填写项目名称', trigger: 'blur' }],
        projectCatalogId: [{ required: true, type: 'number', message: '请选择项目类别', trigger: 'change' }],
        projectSource: [{ required: true, message: '请填写立项部门', trigger: 'blur' }],
        cooperateUnit: [{ required: true, message: '请填写合作单位', trigger: 'blur' }],
        projectAmount: [{ required: true, message: '请填写经费总额', trigger: 'blur' }],
        financialAmount: [{ required: true, message: '请填写其中财政拨款', trigger: 'blur' }],
        ratifyDt: [{ required: true, type: 'date', message: '请填写批准年度', trigger: 'change' }],
        trusteeshipDepId: [{ required: true, type: 'number', message: '请选择项目托管部门', trigger: 'change' }],
        projectLeaderId: [{ required: true, type: 'number', message: '请选择项目负责人', trigger: 'change' }],
        executeLeaderId: [{ required: true, type: 'number', message: '请选择项目执行负责人', trigger: 'change' }],
    }
    mounted() {
        this.GetDic();
    }

    //编辑弹窗
    //更新数据
    @Watch('editData')
    editDataChange(newVal:any, oldVal:any){
        let tempVal = newVal;
        tempVal.projectCatalogId = tempVal.projectCatalog ? tempVal.projectCatalog.id : undefined;
        tempVal.executeLeaderId = tempVal.executeLeader ? tempVal.executeLeader.id : undefined;
        tempVal.projectLeaderId = tempVal.projectLeader ? tempVal.projectLeader.id : undefined;
        tempVal.trusteeshipDepId = tempVal.trusteeshipDep ? tempVal.trusteeshipDep.id : undefined;
        tempVal.projectAmount = tempVal.projectAmount ? String(tempVal.projectAmount) : '';
        tempVal.financialAmount = tempVal.financialAmount ? String(tempVal.financialAmount) : '';
        tempVal.ratifyDt = tempVal.projectCatalog ? new Date(new Date().setFullYear(tempVal.ratifyYear)) : undefined;
        if(tempVal.attachs.length){
            tempVal.attachs.forEach((item:any,index:any) => {
               this.initData.defaultList.push({
                   name:item.attachName,
                   url:item.url,
                   id:item.id
                }); 
            });
        }
        this.initData.disabled = false;
        this.initData.formData = Object.assign({},tempVal);
        this.initData.formData.attachs = [];
        if(!tempVal.members){
            this.initData.createOrUpdateMembers = tempVal.members;
        }
        
    }
}
